import React from 'react';

const Ok = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.046 7.125c0-1.085.879-1.964 1.954-1.964s1.954.88 1.954 1.964c0 1.08-.879 1.955-1.954 1.955a1.96 1.96 0 0 1-1.954-1.955zM22 2.357v17.286A2.358 2.358 0 0 1 19.643 22H2.357A2.358 2.358 0 0 1 0 19.643V2.357A2.358 2.358 0 0 1 2.357 0h17.286A2.358 2.358 0 0 1 22 2.357zM7.017 7.125a3.983 3.983 0 0 0 7.966 0 3.982 3.982 0 1 0-7.965 0zm8.57 4.454c-.226-.446-.85-.825-1.675-.176 0 0-1.115.884-2.912.884s-2.912-.884-2.912-.884c-.825-.649-1.449-.27-1.675.176-.388.791.054 1.164 1.051 1.817.85.545 2.024.747 2.78.825l-.634.634c-.893.884-1.743 1.743-2.342 2.342-.864.865.525 2.25 1.394 1.405l2.343-2.352c.894.893 1.753 1.753 2.342 2.352.865.844 2.26-.526 1.405-1.405l-2.343-2.342-.638-.634c.761-.078 1.92-.29 2.76-.825 1.002-.653 1.439-1.03 1.056-1.817z"
      fill="currentColor"
    />
  </svg>
);

export default Ok;
